import { render, staticRenderFns } from "./ModalConfigCompany.vue?vue&type=template&id=b0887376&"
import script from "./ModalConfigCompany.vue?vue&type=script&lang=js&"
export * from "./ModalConfigCompany.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigCompany.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports